import { FaGithub } from "react-icons/fa"
import { Link, useLocation } from "react-router-dom"
import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import ProductContext from '../../context/products/ProductContext'
import { ReactComponent as OilIcon } from "./assets/oilIcon.svg";
import { ReactComponent as FilterIcon } from "./assets/filterIcon.svg";
import { ReactComponent as DiscIcon } from "./assets/discIcon.svg";
import { ReactComponent as AdditiveIcon } from "./assets/additiveIcon.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { faBottleDroplet } from "@fortawesome/free-solid-svg-icons";
import logo from '../layout/assets/logo.png'
import castrolSmall from '../layout/assets/BrandLogos/CastrolSmall.png'
import elfSmall from '../layout/assets/BrandLogos/ElfSmall.png'
import fuchsSmall from '../layout/assets/BrandLogos/FuchsSmall.png'
import mannolSmall from '../layout/assets/BrandLogos/MannolSmall.png'
import mobilSmall from '../layout/assets/BrandLogos/MobilSmall.png'
import motulSmall from '../layout/assets/BrandLogos/MotulSmall.png'
import shellSmall from '../layout/assets/BrandLogos/ShellSmall.png'
import totalSmall from '../layout/assets/BrandLogos/TotalSmall.png'
import valvolineSmall from '../layout/assets/BrandLogos/ValvolineSmall.png'
import aralSmall from '../layout/assets/BrandLogos/AralSmall.png'


function Navbar({ title }) {
  const [oilDropdownOpen, setOilDropdownOpen] = useState(false);
  const [brandedOpen, setBrandedOpen] = useState(false);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [isOpenDdl, setIsOpenDdl] = useState(false);

  const toggleBranded = () => {
    setBrandedOpen(!brandedOpen);
  };

  const handleDropdownToggle = () => {
    setIsOpenDdl(!isOpenDdl);
  };

  const handleDdlLinkClick = () => {
    setIsOpenDdl(false);
  };

  // Refs for dropdowns to detect outside clicks
  const oilDropdownRef = useRef(null);
  const filterDropdownRef = useRef(null);

  const { cartItems, setCartItems } = useContext(ProductContext)

  const location = useLocation();

  // Close dropdowns when clicked outside
  useEffect(() => {
    const cartFromCookies = Cookies.get('cart') ? JSON.parse(Cookies.get('cart')) : [];
    setCartItems(cartFromCookies);
    const handleClickOutside = (event) => {
      if (
        oilDropdownRef.current && !oilDropdownRef.current.contains(event.target) &&
        filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)
      ) {
        setOilDropdownOpen(false);
        setBrandedOpen(false);
        setFilterDropdownOpen(false);
      }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Function to toggle oil dropdown visibility
  const toggleOilDropdown = (e) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the document
    setOilDropdownOpen((prev) => !prev); // Toggle the dropdown state
  };

  // Function to toggle filter dropdown visibility
  const toggleFilterDropdown = (e) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the document
    setFilterDropdownOpen((prev) => !prev); // Toggle the dropdown state
  };

  // Function to close dropdowns when a link is clicked
  const handleLinkClick = () => {
    setOilDropdownOpen(false);
    setBrandedOpen(false);
    setFilterDropdownOpen(false);
  };

  const getFormattedPrice = (price) => {
    return new Intl.NumberFormat('mk-MK').format(price);
  }

  const handleCloseCart = () => {
    setIsOpen(false); // Кога ќе се кликне, го поставуваме на false за да ја затвориме
  };

  const handleToggleCart = () => {
    setIsOpen(prevState => !prevState); // Превртете ја вредноста на стейтот
  };

  return (
    <nav className="navbar mb-1 shadow-lg bg-myBlue text-neutral-content max-h-16">
      <div className="w-full mx-auto flex justify-between items-center px-4">
        <div className="flex items-center space-x-2">
          <Link to='/' className="text-lg font-bold align-middle whitespace-nowrap">
            <img
              src={logo}
              alt='logo'
              className="max-w-[160px] lg:max-w-[220px]"
            />
          </Link>
        </div>
        <div className="navbar hidden md:flex justify-center">
          <div className="dropdown dropdown-bottom" ref={oilDropdownRef}>
            <div tabIndex={0} role="button" className={`btn btn-ghost hover:text-myOrange text-bold ${location.pathname === '/oils' ? 'text-myOrange' : ''}`} onClick={toggleOilDropdown}
            ><OilIcon className="w-6 h-6 fill-current scale-100 inline" />Масла</div>
            {oilDropdownOpen && (
              <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[40] w-52 p-2 shadow text-neutral" >
                <li className="hover:text-myOrange"><Link to='/oils' onClick={handleLinkClick}>Сите масла</Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Mobil' onClick={handleLinkClick}>Mobil<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={mobilSmall} alt="Mobil" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Motul' onClick={handleLinkClick}>Motul<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={motulSmall} alt="Motul" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Valvoline' onClick={handleLinkClick}>Valvoline<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={valvolineSmall} alt="Valvoline" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Castrol' onClick={handleLinkClick}>Castrol<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={castrolSmall} alt="Castrol" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Shell' onClick={handleLinkClick}>Shell<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={shellSmall} alt="Shell" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full whitespace-nowrap" to='/oils?manufacturer=Fuchs' onClick={handleLinkClick}>Fuchs Titan<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={fuchsSmall} alt="Fuchs" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Total' onClick={handleLinkClick}>Total<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={totalSmall} alt="Total" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Elf' onClick={handleLinkClick}>Elf<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={elfSmall} alt="Elf" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Mannol' onClick={handleLinkClick}>Mannol<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={mannolSmall} alt="Mannol" /></div></Link></li>
                <li className="hover:text-myOrange"><Link className="flex items-center justify-between w-full" to='/oils?manufacturer=Aral' onClick={handleLinkClick}>Aral<div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={aralSmall} alt="Aral" /></div></Link></li>

                <li className="relative">
                  <button onClick={toggleBranded} className="w-full text-left">Брендирани масла &#10132;</button>
                  {brandedOpen && (
                    <ul className="menu bg-base-100 rounded-box p-2 shadow absolute top-0 left-full ml-2 w-48">
                      <li className="hover:text-myOrange">
                        <Link to="/oils?manufacturer=BMW" onClick={handleLinkClick}>BMW</Link>
                      </li>
                      <li className="hover:text-myOrange">
                        <Link to="/oils?manufacturer=Mercedes-Benz" onClick={handleLinkClick}>Mercedes-Benz</Link>
                      </li>
                      <li className="hover:text-myOrange">
                        <Link to="/oils?manufacturer=VAG" onClick={handleLinkClick}>Volkswagen (VAG)</Link>
                      </li>
                      <li className="hover:text-myOrange">
                        <Link to="/oils?manufacturer=GM" onClick={handleLinkClick}>Opel GM</Link>
                      </li>
                      <li className="hover:text-myOrange">
                        <Link to="/oils?manufacturer=Ford" onClick={handleLinkClick}>Ford</Link>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>)}
          </div>
          <div className="dropdown dropdown-bottom" ref={filterDropdownRef}>
            <div tabIndex={0} role="button"
              className={`btn btn-ghost hover:text-myOrange text-bold ${location.pathname === '/allfilters' ||
                location.pathname === '/oilfilters' ||
                location.pathname === '/airfilters' ||
                location.pathname === '/fuelfilters' ||
                location.pathname === '/cabinfilters'
                ? 'text-myOrange' : ''}`} onClick={toggleFilterDropdown} // Toggle dropdown without closing immediately
            ><FilterIcon className="w-6 h-6 fill-current scale-100 inline" />Филтри</div>
            {filterDropdownOpen && (
              <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[40] w-52 p-2 shadow text-neutral" >
                <li className="hover:text-myOrange"><Link to='/allfilters' onClick={handleLinkClick}>Сите филтри</Link></li>
                <li className="hover:text-myOrange"><Link to='/oilfilters' onClick={handleLinkClick}>Филтер за масло</Link></li>
                <li className="hover:text-myOrange"><Link to='/airfilters' onClick={handleLinkClick}>Филтер за воздух</Link></li>
                <li className="hover:text-myOrange"><Link to='/fuelfilters' onClick={handleLinkClick}>Филтер за гориво</Link></li>
                <li className="hover:text-myOrange"><Link to='/cabinfilters' onClick={handleLinkClick}>Филтер за кабина</Link></li>
              </ul>)
            }
          </div>
          <div className="dropdown dropdown-bottom">
            <div tabIndex={0} role="button" className={`btn btn-ghost hover:text-myOrange text-bold ${location.pathname === '/kocnici' ? 'text-myOrange' : ''}`}
            ><Link to='/kocnici' className=""><DiscIcon className="w-6 h-6 fill-current scale-100 inline"  /> Кочници</Link></div>
          </div>
          <div className="dropdown dropdown-bottom">
            <div tabIndex={0} role="button" className={`btn btn-ghost hover:text-myOrange text-bold ${location.pathname === '/additives' ? 'text-myOrange' : ''}`}
            ><Link to='/additives' className=""><FontAwesomeIcon icon={faBottleDroplet} className="mr-1 text-lg inline " /> Адитиви</Link></div>
          </div>
          <div className="dropdown dropdown-bottom">
            <Link to='/about'>
              <div
                tabIndex={0}
                role="button"
                className={`btn btn-ghost sm:btn-sm hover:text-myOrange text-bold ${location.pathname === '/about' ? 'text-myOrange' : ''}`}
              >
                За нас
              </div>
            </Link>
          </div>
          <div className="dropdown dropdown-bottom">
            <Link to='/contact'>
              <div
                tabIndex={0}
                role="button"
                className={`btn btn-ghost sm:btn-sm hover:text-myOrange text-bold ${location.pathname === '/contact' ? 'text-myOrange' : ''}`}
              >
                Контакт
              </div>
            </Link>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle" onClick={handleToggleCart}>
              <div className="indicator">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span className="badge badge-sm indicator-item text-myOrange">{cartItems.length ?? 0}</span>
              </div>
            </div>
            <div
              tabIndex={0}
              className={`card card-compact dropdown-content bg-base-100 z-[40] mt-3 w-64 shadow-xl rounded-lg p-4 ${isOpen ? 'block' : 'hidden'}`}>
              <div className="card-body text-neutral">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-semibold">
                    {cartItems.length === 0 ? 'Немате додадено' : `Имате ${cartItems.length}`} производи
                  </span>
                  <FontAwesomeIcon icon={faCartShopping} />
                </div>

                <div className="my-2">
                  <span className="text-lg text-gray-500">Вкупно: </span>
                  <span className="text-lg font-bold text-myOrange">{getFormattedPrice(cartItems?.length > 0 ? cartItems.reduce((acc, item) => acc + item.totalPrice, 0) : 0)} денари</span>
                </div>

                <div className="card-actions mt-4">
                  <Link to='/cart' className="btn btn-secondary btn-block rounded-md shadow-lg transition-all hover:bg-primary-focus"
                    onClick={handleCloseCart}>
                    Види кошничка
                  </Link>
                </div>
              </div>
            </div>

          </div>
          <div className="dropdown dropdown-end md:hidden">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost"
              onClick={handleDropdownToggle} // Toggle на dropdown-от
            >
              <div className="w-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h8m-8 6h16"
                  />
                </svg>
              </div>
            </div>

            {isOpenDdl && ( 
              <ul
                tabIndex={0}
                className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[40] mt-3 w-80 p-2 shadow"
              >
                <li className="relative group">
                  <a className="text-neutral text-lg hover:text-myOrange">Масла</a>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu bg-base-100 rounded-box z-[40] absolute left-11 top-full w-52 p-2 shadow text-neutral group-hover:block hidden border-2 border-myOrange"
                  >
                    <li className="hover:text-myOrange">
                      <div>
                        <Link to="/oils" className="text-base" onClick={handleDdlLinkClick}>
                          Сите масла
                        </Link>
                      </div>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Mobil"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Mobil
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={mobilSmall} alt="Mobil" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Motul"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Motul
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={motulSmall} alt="Motul" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Valvoline"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Valvoline
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={valvolineSmall} alt="Valvoline" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Castrol"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Castrol
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={castrolSmall} alt="Castrol" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Shell"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Shell
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={shellSmall} alt="Shell" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Fuchs"
                        className="text-base flex items-center justify-between w-full whitespace-nowrap"
                        onClick={handleDdlLinkClick}
                      >
                        Fuchs Titan
                        <div className="w-16 flex justify-start "><img className=" object-contain" src={fuchsSmall} alt="Fuchs" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Total"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Total
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={totalSmall} alt="Total" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Elf"
                        className="text-base flex items-center justify-between w-full flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Elf
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={elfSmall} alt="Elf" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Mannol"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Mannol
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={mannolSmall} alt="Mannol" /></div>
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oils?manufacturer=Aral"
                        className="text-base flex items-center justify-between w-full"
                        onClick={handleDdlLinkClick}
                      >
                        Aral
                        <div className="w-16 flex justify-start ml-4"><img className=" object-contain" src={aralSmall} alt="Aral" /></div>
                      </Link>
                    </li>
                    <li className="ml-3 p-2 font-bold text-neutral">
                      Брендирани масла
                    </li>
                    <li className="hover:text-myOrange ml-3">
                      <Link to="/oils?manufacturer=BMW" onClick={handleDdlLinkClick}>BMW</Link>
                    </li>
                    <li className="hover:text-myOrange ml-3">
                      <Link to="/oils?manufacturer=Mercedes-Benz" onClick={handleDdlLinkClick}>Mercedes-Benz</Link>
                    </li>
                    <li className="hover:text-myOrange ml-3">
                      <Link to="/oils?manufacturer=VAG" onClick={handleDdlLinkClick}>Volkswagen (VAG)</Link>
                    </li>
                    <li className="hover:text-myOrange ml-3">
                      <Link to="/oils?manufacturer=GM" onClick={handleDdlLinkClick}>Opel GM</Link>
                    </li>
                    <li className="hover:text-myOrange ml-3">
                      <Link to="/oils?manufacturer=Ford" onClick={handleDdlLinkClick}>Ford</Link>
                    </li>
                  </ul>
                </li>
                <li className="relative group">
                  <a className="text-neutral text-lg hover:text-myOrange">Филтри</a>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu bg-base-100 rounded-box z-[40] absolute left-12 top-full w-52 p-2 shadow text-neutral group-hover:block hidden border-2 border-myOrange"
                  >
                    <li className="hover:text-myOrange">
                      <Link
                        to="/allfilters"
                        className="text-base"
                        onClick={handleDdlLinkClick}
                      >
                        Сите филтри
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/oilfilters"
                        className="text-base"
                        onClick={handleDdlLinkClick}
                      >
                        Филтер за масло
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/airfilters"
                        className="text-base"
                        onClick={handleDdlLinkClick}
                      >
                        Филтер за воздух
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/fuelfilters"
                        className="text-base"
                        onClick={handleDdlLinkClick}
                      >
                        Филтер за гориво
                      </Link>
                    </li>
                    <li className="hover:text-myOrange">
                      <Link
                        to="/cabinfilters"
                        className="text-base"
                        onClick={handleDdlLinkClick}
                      >
                        Филтер за кабина
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="text-neutral">
                  <Link
                    to="/kocnici"
                    className="text-lg hover:text-myOrange"
                    onClick={handleDdlLinkClick}
                  >
                    Кочници
                  </Link>
                </li>
                <li className="text-neutral">
                  <Link
                    to="/additives"
                    className="text-lg hover:text-myOrange"
                    onClick={handleDdlLinkClick}
                  >
                    Адитиви
                  </Link>
                </li>
                <li className="text-neutral">
                  <Link
                    to="/about"
                    className="text-lg hover:text-myOrange"
                    onClick={handleDdlLinkClick}
                  >
                    За нас
                  </Link>
                </li>
                <li className="text-neutral">
                  <Link
                    to="/contact"
                    className="text-lg hover:text-myOrange"
                    onClick={handleDdlLinkClick}
                  >
                    Контакт
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </nav >
  )
}

Navbar.propTypes = {
  title: PropTypes.string,
}

export default Navbar
